export const DataQueryParamPersonName = 'personName';
